import { render, staticRenderFns } from "./edit-language.vue?vue&type=template&id=1f4c6099&scoped=true&"
import script from "./edit-language.vue?vue&type=script&lang=ts&"
export * from "./edit-language.vue?vue&type=script&lang=ts&"
import style0 from "./edit-language.vue?vue&type=style&index=0&id=1f4c6099&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c6099",
  null
  
)

component.options.__file = "edit-language.vue"
export default component.exports